/**
 * 政府端 — 运输档案（4 项哈希 + 存证状态）
 */
import { useEffect, useState } from 'react';
import { fetchOrders, fetchArchive } from '@/api/transit';
import { Empty, HashCell, Loading, PageHeader, StatusTag } from '@/components/common';
import type { TransitArchive, TransitOrder } from '@/types';
import { archiveStatusText, fmtTime } from '@/utils/format';

export default function GovArchives() {
  const [orders, setOrders] = useState<TransitOrder[]>([]);
  const [archives, setArchives] = useState<Record<number, TransitArchive | null>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders({ page_size: 100 }).then(async (d) => {
      setOrders(d.list);
      const map: Record<number, TransitArchive | null> = {};
      for (const o of d.list) {
        map[o.id] = await fetchArchive(o.id);
      }
      setArchives(map);
      setLoading(false);
    });
  }, []);

  if (loading) return <Loading />;

  const list = orders
    .filter((o) => archives[o.id] != null)
    .map((o) => ({ order: o, archive: archives[o.id] as TransitArchive }));

  return (
    <div>
      <PageHeader title="运输档案" sub="运输单号 / 轨迹哈希 / 证照哈希 / 签收信息哈希 4 项上链存证" />
      <div className="card">
        {list.length === 0 ? (
          <Empty text="暂无已存证档案（签收完成后自动构建）" />
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>运输单号</th>
                <th>轨迹哈希</th>
                <th>证照哈希</th>
                <th>签收哈希</th>
                <th>链上交易</th>
                <th>状态</th>
                <th>上链时间</th>
              </tr>
            </thead>
            <tbody>
              {list.map(({ archive }) => (
                <tr key={archive.id}>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{archive.transit_no}</td>
                  <td>
                    <HashCell value={archive.track_hash} />
                  </td>
                  <td>
                    <HashCell value={archive.cert_hash} />
                  </td>
                  <td>
                    <HashCell value={archive.sign_hash} />
                  </td>
                  <td>
                    <HashCell value={archive.tx_hash} />
                  </td>
                  <td>
                    <StatusTag tone={archive.status === 1 ? 'green' : archive.status === 2 ? 'red' : 'amber'}>
                      {archiveStatusText(archive.status)}
                    </StatusTag>
                  </td>
                  <td style={{ fontSize: 12, color: 'var(--color-ink-secondary)' }}>{fmtTime(archive.block_time ?? archive.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
